import { api } from '@/global/services/api'
import { notify } from '@/global/services/notification/notificationBus'

export default {
  name: 'documentHistoryHelper',

  data () {
    return {
      logsData: {},
      logsShowLoader: false,
      showPreviewLoader: false
    }
  },

  methods: {
    async fetchHistoryDocuments (documentType, documentsKey) {
      const { id } = this.$route?.params || {}

      if (!id) {
        console.error('Missing traffic regulation id')
        return
      }

      if (typeof documentType !== 'string' || !documentType) {
        console.error('Invalid or missing document type')
        return
      }

      if (typeof documentsKey !== 'string' || !documentsKey) {
        console.error('Invalid or missing documents key')
        return
      }

      this.logsShowLoader = true

      try {
        const { data } = await api('road-maintenance').get(
          `traffic-regulation/${id}/${documentType}/history`
        )

        this.$set(this.logsData, documentsKey, data)
      }
      catch (error) {
        console.error('Error fetching document history:', error)
      }
      finally {
        this.logsShowLoader = false
      }
    },

    async downloadDocument (event) {
      const { id: documentId, name } = event?.data || {}
      const { id: trafficRegulationId } = this.$route?.params || {}

      if (!documentId || !trafficRegulationId) {
        notify(this.$t('road-maintenance/aggregator.invalid_file_id'))
        return
      }

      const url = new URL(`${window.location.origin}/api/road-maintenance/traffic-regulation/${trafficRegulationId}/document/${documentId}`)
      let objectURL = null

      try {
        const response = await fetch(url.toString(), {
          method: 'POST'
        })

        if (!response.ok) {
          const contentType = response.headers.get('Content-type') || ''

          let errorMessage
          if (contentType.includes('text/plain')) {
            // Laravel returned plain text
            errorMessage = await response.text()
          }
          else if (contentType.includes('application/json')) {
            // Laravel returned JSON
            const errorData = await response.json()
            errorMessage = errorData.message || JSON.stringify(errorData)
          }
          else {
            // Probably HTML (default Laravel error page)
            errorMessage = this.$t('road-maintenance/aggregator.not_possible_download_document')
          }

          notify(errorMessage)
          return
        }

        const arrayBuffer = await response.arrayBuffer()

        // Create a Blob from the response data
        const blob = new Blob([new Uint8Array(arrayBuffer)], {
          type: 'application/pdf'
        })

        // Generate object URL for downloading
        objectURL = URL.createObjectURL(blob)
        const filename = name ? name + '.pdf' : 'pdf_preview.pdf'

        // Trigger download
        const link = document.createElement('a')
        link.href = objectURL
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }
      catch (exception) {
        console.error('Error showing pdf:', exception.message || exception)
      }
      finally {
        // Revoke object URL to release memory
        if (objectURL) {
          URL.revokeObjectURL(objectURL)
        }
      }
    },

    async previewDocument (event = {}, documentType) {
      let previewWindow = null

      try {
        const { id: trafficRegulationId } = this.$route?.params || {}
        const { html } = event?.formData || {}

        if (!trafficRegulationId || !documentType || !html || typeof html !== 'string') {
          notify(this.$t('road-maintenance/aggregator.not_possible_download_document'))
          return
        }

        // Open the tab while still inside the click, otherwise the popup blocker stops it
        previewWindow = window.open('', '_blank')
        if (previewWindow) {
          previewWindow.document.title = 'PDF'
          previewWindow.document.body.style.fontFamily = 'sans-serif'
          previewWindow.document.body.textContent = 'Učitavanje PDF-a...'
        }
        this.showPreviewLoader = true

        const formData = new FormData()
        formData.append('html', html)

        const previewUrl = `${window.location.origin}/api/road-maintenance/traffic-regulation/${trafficRegulationId}/${documentType}/preview`
        const response = await fetch(previewUrl, {
          method: 'POST',
          body: formData
        })
        const { data } = response.ok ? await response.json() : {}

        if (!data?.token) {
          previewWindow?.close()
          notify(this.$t('road-maintenance/aggregator.not_possible_download_document'))
          return
        }

        // The stored preview is served over GET, so the PDF viewer can download it
        // again and the server gives it a meaningful file name
        const pdfUrl = `${previewUrl}/${data.token}`

        if (previewWindow) {
          previewWindow.location.href = pdfUrl
        }
        else {
          window.open(pdfUrl, '_blank')
        }
      }
      catch (exception) {
        previewWindow?.close()
        console.error('Error showing pdf:', exception.message || exception)
      }
      finally {
        this.showPreviewLoader = false
      }
    },

    async createFromVersion (event, documentType) {
      const { data: eventData } = event || {}
      const { document_data_id: documentDataId } = eventData || {}

      // cant create document if document data id is invalid
      if (!documentDataId || !documentType) {
        notify(this.$t('road-maintenance/aggregator.generate_document_not_possible'))
        return
      }

      // make form data
      const formData = new FormData()
      formData.append('document_data_id', documentDataId)

      // get document data
      const { data } = await api('road-maintenance').post(`traffic-regulation/${this.$route.params.id}/${documentType}`, formData)
      return data
    }
  }
}
